
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[resourcePage]",
      function () {
        return require("private-next-pages/resources/[resourcePage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[resourcePage]"])
      });
    }
  